module.exports = __webpack_public_path__ + "static/media/karachi-r1-dark.9a569e31.svg";